import { Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { OverridableStringUnion } from '@mui/types';
import { Variant } from '@mui/material/styles/createTypography';
import { TypographyPropsVariantOverrides } from '@mui/material/Typography/Typography';

interface Props {
  text: string;
  children?: ReactNode;
  headerVariant?: OverridableStringUnion<
    Variant | 'inherit',
    TypographyPropsVariantOverrides
  >;
}
export const TabHeader = ({ text, children, headerVariant = 'h4' }: Props) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: '24px',
      alignItems: 'center',
    }}
  >
    <Typography variant={headerVariant} display="inline">
      {text}
    </Typography>
    <div>{children}</div>
  </div>
);
